import React from 'react'
import {CheckCircle} from 'lucide-react'

export default function Benefits() {
  const benefits = [
    'Apostila digital com o conteúdo estrutural da Petrobras',
    'Material direto ao ponto, focado no que se repete nos editais',
    'Estude no celular, tablet ou computador',
    'Acesso imediato após o pagamento',
    'Garantia incondicional de 7 dias'
  ]

  return (
    <section className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl font-bold text-[#003D23] mb-10 text-center">
          O que você recebe
        </h2>
        
        <div className="space-y-4">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start gap-3">
              <CheckCircle className="w-6 h-6 text-[#006B3F] flex-shrink-0 mt-1" />
              <p className="text-lg text-gray-700">{benefit}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}